<template>
  <div class="">
    <van-nav-bar
      title="额度申请表"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <!-- <div class="tab">
      <ul>
        <li @click="changecolour">
          公司
          <div :class="{ di: dis }"></div>
        </li>
        <li @click="changecolour2">
          个体工商户
          <div :class="{ di: !dis }"></div>
        </li>
      </ul>
    </div> -->
   
    <div
      class=""
      style="height:0.3rem"
    ></div>
    <van-form @submit="onSubmit">
      <van-field
        readonly
        clickable
        name="type"
        :value="value1"
        label="选择申请类型"
        placeholder="点击选择申请类型"
        @click="showPicker = true"
        :rules="[{ required: true, message: '请选择申请类型' }]"
      />
      <van-popup
        v-model="showPicker"
        position="bottom"
      >
        <van-picker
          show-toolbar
          :columns="columns"
          value-key="1"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />

      </van-popup>
      <van-field
        v-model="confirm"
        type="text"
        name="quota"
        label="申请额度 单位万"
        placeholder="请填写申请额度"
        
        :rules="[{ required: true, message: '请填写申请额度' }]"
      />

    
      <!-- <van-field
        v-model="address"
        type="text"
        name="address"
        label="您的详细地址"
        placeholder="请填写详细地址(选填)"
      /> -->
      <!-- <van-field
        v-model="mailbox"
        type="text"
        name="mailbox"
        label="邮箱"
        placeholder="请输入邮箱(选填)"
      /> -->
      <van-field
        name="uploader_img"
        label="营业执照上传"
        :rules="[{ required: true, message: '请上传营业执照' }]"
      >
        <template #input>
          <van-uploader
            max-size="113122150"
            accept="image/*"
            @oversize="oversize"
            :after-read="afterRead"
            v-model="fileList"
            max-count="1"
          />
        </template>
      </van-field>
<van-field
        name="uploader_img"
        label="身份证照片上传"
        :rules="[{ required: true, message: '请上传身份证照片' }]"
      >
        <template #input>
          <van-uploader
            max-size="113122150"
            accept="image/*"
            @oversize="oversize"
            :after-read="afterRead2"
            v-model="fileList2"
            max-count="2"
            @delete="san"
          />
        </template>
      </van-field><van-field
        name="uploader_img"
        label="营业场所实地照上传"
        :rules="[{ required: true, message: '请上传营业场所实地照' }]"
      >
        <template #input>
          <van-uploader
            max-size="113122150"
            accept="image/*"
            @oversize="oversize"
            :after-read="afterRead3"
            v-model="fileList3"
            max-count="1"
          />
        </template>
      </van-field><van-field
        name="uploader_img"
        label="担保措施资料上传"
        :rules="[{ required: true, message: '请上传担保措施资料' }]"
      >
        <template #input>
          <van-uploader
            max-size="113122150"
            accept="image/*"
            @oversize="oversize"
            :after-read="afterRead4"
            v-model="fileList4"
            max-count="1"
          />
        </template>
      </van-field>
      <div class="checkbox">
        <van-checkbox
          v-model="checked"
          :label-disabled="true"
        >
          我以阅读并同意<span @click="goagreement">《货空间鲸信用服务协议》</span></van-checkbox>
      </div>
      <div style="margin: 16px;">
        <van-button
          round
          block
          type="info"
          native-type="submit"
        >
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from 'vue'
// import areaList from '../../../assets/area'

import {
  NavBar,
  Button,
  Uploader,
  Field,
  Form,
  Checkbox,
  CheckboxGroup,
  Toast,
  Picker,
  Popup,
  Area, Dialog
} from 'vant'
Vue.use(NavBar)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(Form)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Toast).use(Picker).use(Popup).use(Area).use(Dialog)
export default {
  created () {
    // console.log(this.$store.state.address)

    // this.id = this.$route.params.id
    
  },
  data () {
    return {
      petname: '',
      username: '',
      password: '',
      confirm: '',
      mobile: '',
      recommend: '', //
      address: '',
      mailbox: '',
      tlist: ["个人", "个体工商户", "个人独资企业", "有限责任公司"],
      tslist: ["个人经营定税", "小规模纳税人", "一般纳税人"],
      fileList: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      sms: '',
      dis: true,
      checked: false,
      time: 60,
      shopid: '',
      recommendid: '',
      timetxt: '发送验证码',
      but: false,
      value: "",
      value1: "",
      recommends: '',
      tax: '',
      columns: ['固定额度','额度调整','临时单比额度'],
      columnsid: [],
      columns2: [],
      columns2id: [],
      showPicker: false,
      showPicker2: false,
      showPicker3: false,
      showPicker4: false,
      types: "",
      area: '',
      showArea: false,
    
      userfalg: true,
      mobilefalg: true,
      imgfalge: false,
      wz: '',
      telephone: '',
      yz:'',
      yz2:[],
      yz3:'',
      yz4:'',
    }
  },
  watch: {

  },
  methods: {
    // up (e) {
    //   let file = e.target.files[0];
    //   // console.log(e.target.name)
    //   var param = new FormData(); // 创建form对象
    //   param.append("image", file, file.name);
    //   console.log(param)
    //   this.axios.post('uploadCertificate', param, {
    //     headers: { "Content-Type": "multipart/form-data" }
    //   }).then(res => {
    //     console.log(res)
    //   }).catch(ref => {
    //     console.log(ref)
    //   })
    // },
    gotelephone (i) {
      Dialog.confirm({
        title: '电话客服',
        message: i,
        confirmButtonText: '呼叫'
      })
        .then(() => {
          // on confirm
          window.location.href = "tel:" + i
        }).catch(() => { })
    },
    panduan () {
      // console.log(1)
      if (this.username.trim() == "") {
        Toast("名称不能为空")
      } else {
        this.axios.post("usernameIsResiter", { username: this.username.trim() }).then(res => {
          if (res.data.code == 400) {
            Toast(res.data.msg)
            this.userfalg = false
          } else {
            this.userfalg = true
          }
        }).catch(ref => {
          console.log(ref)
        })
      }
    },
    panduanm () {
      // console.log(1)
      if (this.mobile) {
        if (/^1[23456789]\d{9}$/.test(this.mobile)) {
        } else {
          Toast('请输入正确手机号')
          return
        }
      } else {
        Toast('请输入手机号')
        return
      }
      this.axios.post("mobileIsResiter", { mobile: this.mobile }).then(res => {
        if (res.data.code == 400) {
          Toast(res.data.msg)
          this.mobilefalg = false
        } else {
          this.mobilefalg = true

        }
      }).catch(ref => {
        console.log(ref)
      })
    },
    onArea (values) {
      this.area = values.map((item) => item.name).join('/');
      this.showArea = false;
    },
    onConfirm (value, i) {
     
      this.value1 = value;
      this.recommendid = i+1
   
      this.showPicker = false;

    },
    onConfirm2 (value, i) {
      this.recommends = value;
      this.recommendid = this.columns2id[i]
      this.showPicker2 = false;
    },
    onConfirm3 (value, i) {
      this.types = value;
      this.showPicker3 = false;
    },
    onConfirm4 (value, i) {
      this.tax = value;
      this.showPicker4 = false;
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    onSubmit (v) {
      // console.log(v)
      if(this.checked){}else{
        Toast('请先阅读服务协议')
        return
      }
     if(this.yz2.length!=2){
      Toast('身份证请上传正反面')
        return
     }
      v.tu1= this.yz
      v.tu2= this.yz2
      v.tu3= this.yz3
      v.tu4= this.yz4
      v.type= this.recommendid
      v.uploader_img=''
      console.log(v)
      // return false
      this.axios.post("applyQuota", v).then(res => {
        if (res.data.code == 400) {
          Toast(res.data.msg)
        }
        if (res.data.code == 200) {
          Toast(res.data.msg)
          // this.$router.push('login')
        }
      }).catch(ref => {
        console.log(ref)
      })

    },

    changecolour () {
      this.dis = true
    },
    changecolour2 () {
      this.dis = false
    },
    goagreement () {
      this.$router.push('bai3')
    },
 goagreement1 () {
      this.$router.push('agreement1')
    },
    timego () {
      if (this.mobile) {
        if (/^1[23456789]\d{9}$/.test(this.mobile)) {
        } else {
          Toast('请输入正确手机号')
          return
        }
      } else {
        Toast('请输入手机号')
        return
      }
      // this.axios.post("sendSmsCode", { mobile: this.mobile }).then(res => {
      //   Toast('发送成功')
      //   this.but = true
      //   var timer = setInterval(() => {
      //     this.time--
      //     this.timetxt = '请' + this.time + '秒后发送'
      //     if (this.time === 0) {
      //       this.but = false
      //       clearInterval(timer)
      //       this.time = 60
      //       this.timetxt = '发送验证码'
      //     }
      //   }, 1000)
      // }).catch(ref => {
      //   console.log(ref)
      // })

    },
    oversize () {
      Toast('请上传10m之内的图片')

    },
    afterRead (file) {
      // 此时可以自行将文件上传至服务器
      // console.log(file)
      file.status = 'uploading';
      file.message = '上传中...';

      // setTimeout(() => {
      //   file.status = 'failed';
      //   file.message = '上传失败';
      // }, 1000)

      if (file.file.size > 11312215) {
        file.status = 'failed';
        file.message = '上传失败';
        Toast('请上传10m之内的图片')
        return
      }
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append('image', file.file)
      console.log(1)
      this.axios.post('uploadCertificate', formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res)
        file.status = 'done';
        this.yz = res.data.path
        this.imgfalge = true

      }).catch(ref => {
        file.status = 'failed';
        file.message = '上传失败';
        console.log(ref)
      })

    },
    afterRead2 (file) {
      // 此时可以自行将文件上传至服务器
      // console.log(file)
      file.status = 'uploading';
      file.message = '上传中...';

      // setTimeout(() => {
      //   file.status = 'failed';
      //   file.message = '上传失败';
      // }, 1000)

      if (file.file.size > 11312215) {
        file.status = 'failed';
        file.message = '上传失败';
        Toast('请上传10m之内的图片')
        return
      }
      var formData2 = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData2.append('image', file.file)
      console.log(1)
      this.axios.post('uploadCertificate', formData2, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res)
        file.status = 'done';
        this.yz2.push(res.data.path)
        this.imgfalge = true

      }).catch(ref => {
        file.status = 'failed';
        file.message = '上传失败';
        console.log(ref)
      })

    },
    afterRead3 (file) {
      // 此时可以自行将文件上传至服务器
      // console.log(file)
      file.status = 'uploading';
      file.message = '上传中...';

      // setTimeout(() => {
      //   file.status = 'failed';
      //   file.message = '上传失败';
      // }, 1000)

      if (file.file.size > 11312215) {
        file.status = 'failed';
        file.message = '上传失败';
        Toast('请上传10m之内的图片')
        return
      }
      var formData3 = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData3.append('image', file.file)
      console.log(1)
      this.axios.post('uploadCertificate', formData3, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res)
        file.status = 'done';
        this.yz3 = res.data.path
        this.imgfalge = true

      }).catch(ref => {
        file.status = 'failed';
        file.message = '上传失败';
        console.log(ref)
      })

    },
    san(i,v){
      console.log(v)
      this.yz2.splice(v.index,1)
    },
    afterRead4 (file) {
      // 此时可以自行将文件上传至服务器
      // console.log(file)
      file.status = 'uploading';
      file.message = '上传中...';

      // setTimeout(() => {
      //   file.status = 'failed';
      //   file.message = '上传失败';
      // }, 1000)

      if (file.file.size > 11312215) {
        file.status = 'failed';
        file.message = '上传失败';
        Toast('请上传10m之内的图片')
        return
      }
      var formData4 = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData4.append('image', file.file)
      console.log(1)
      this.axios.post('uploadCertificate', formData4, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res)
        file.status = 'done';
        this.yz4 = res.data.path
        this.imgfalge = true

      }).catch(ref => {
        file.status = 'failed';
        file.message = '上传失败';
        console.log(ref)
      })

    },
  },
  components: {},
}
</script>

<style lang="less" scoped>
.top {
  width: 100%;
  height: 0.2rem;
}

.tab {
  ul {
    li {
      float: left;
      width: 50%;
      height: 1rem;
      text-align: center;
      line-height: 1rem;
      .di {
        width: 2rem;
        height: 0.3rem;
        background-color: #a22d2b;
        margin: 0 auto;
      }
    }
  }
}
.checkbox {
  padding-top: 0.5rem;
  padding-left: 10%;
  span {
    color: #f00;
  }
}
.van-cell__value {
  overflow: auto;
}
</style>
